import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import customLanguageTexts from '../../../language'
import './index.css'

const ModalAppCreationFailedException = () => {
  const settings = useSelector(state => state.settings)
  const dispatch = useDispatch()
  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'appCreationFailedException'
  const visible = modalID === visibleModalID
  return (
    <Modal
      className="custom__success__modal"
      title={<div>App Creation Failed!</div>}
      onCancel={handleCancel}
      afterClose={handleCancel}
      open={visible}
      footer={null}
      maskClosable={false}
    >
      <div className="p-0">
        <div>
          <div>{customLanguageTexts.APP_CREATION_FAILED_EXCEPTION}</div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalAppCreationFailedException
